export const subscribeUser = async (email: string, topic: string, source: string) => {
  const apiKey = import.meta.env.VITE_MAILERLITE_API_KEY;
  const apiUrl = 'https://connect.mailerlite.com/api/subscribers';

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${apiKey}`,
  };

  const params = {
    email,
    fields: {
      topic,
      source,
    },
    groups: ['157296989463119706'], // Dominicoders
    status: 'active',
  };

  const body = JSON.stringify(params);

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: body,
    });

    if (response.ok) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error subscribing user:', error);
    return false;
  }
};
